module.exports = __webpack_public_path__ + "assets/cal-check.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cal-check.png
// module id = 1179
// module chunks = 7